import React, { useState, useEffect } from 'react'
import { Form, Row, Col, Button, Container, ButtonGroup, ToggleButton, Stack } from 'react-bootstrap';
import axios from 'axios';
import { useParams } from "react-router-dom";
import { BASE_API_URL } from '../../config/Url-config';
import { TbCircleNumber1, TbCircleNumber2, TbCircleNumber3, TbZoomReset } from "react-icons/tb";
import AdminHomeCourse from '../Audit_Report_Components/AdminHomeCourse';
import HomeDeficiencyReport from '../Audit_Report_Components/HomeDeficiencyReport';
import HomeSummary from '../Audit_Report_Components/HomeSummary';
import CourseExpiryReport from '../Audit_Report_Components/CourseExpiryReport';
import PolicyExpiryReport from '../Audit_Report_Components/PolicyExpiryReport';
import HomePolicySummary from '../Audit_Report_Components/HomePolicySummary';
import FundedTrainingReport from '../Audit_Report_Components/FundedTrainingReport';
import HomeStaffSummary from '../Audit_Report_Components/HomeStaffSummary';
import SpinnerBox from '../Utility/SpinnerBox';
import ErrorPopUp from '../Utility/ErrorPopUp';
import * as apiUtility from "../../config/APIUtils";
import JoyButton from '@mui/joy/Button';
import { Box, Sheet, Typography } from '@mui/joy';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';

function HomeAuditReportManagement(props) {

    var radios = [
        { name: 'Home', value: '2' }
    ];

    const staffStatus = [
        { name: 'Active', value: '6' },
        { name: 'Archive', value: '7' },
        { name: 'Both', value: '8' }
    ];

    const crsPolicyType = [
        { name: 'Courses', value: '9' },
        { name: 'Home Docs', value: '10' },
        { name: 'Both', value: '11' }
    ];

    const homeReportTypes = [
        { name: 'Home Summary', value: '4' },
        { name: 'Home Staff Summary', value: '5' },
        { name: 'Home Deficiency Report', value: '6' },
        { name: 'Home Course/Docs role Report', value: '7' },
        { name: 'Users Expiry Report', value: '8' },
        { name: 'Funded Training Submissions', value: '9' }
    ];

    const [userId, setUserId] = useState("");
    const [organisations, setOrganisations] = useState([]);

    const [homeName, setHomeName] = useState('');

    const [homes, setHomes] = useState([]);
    const [defaultHomesList, setDefaultHomesList] = useState([]);
    const [homeDropdownValue, sethomeDropdownValue] = useState(0);
    const [orgDropdownValue, setorgDropdownValue] = useState(0);
    const [radioValue, setRadioValue] = useState('2');
    const [homeStatusValue, setHomeStatusValue] = useState('3');
    const [homeStaffStatusValue, setHomeStaffStatusValue] = useState('6');
    const [homeCrsPolicyValue, setHomeCrsPolicyValue] = useState('9');

    const [courseExpiryValue, setCourseExpiryValue] = useState('9');
    const [expDate, setExpDate] = useState({ 'startDate': (new Date()).toISOString().split('T')[0], 'endDate': getNextMonthDate() });
    const [userExpDate, setUserExpDate] = useState({ 'startDate': '', 'endDate': '' });
    const [homeLabel, setHomeLabel] = useState("Active Homes");
    const [reportSection, setreportSection] = useState("");
    const [selectedReportType, setselectedReportType] = useState(0);
    const [selectedReportName, setselectedReportName] = useState('No report selected');
    const [selectedRole, setselectedRole] = useState(0);
    const [roles, setRoles] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');
    const [spinnerBox, setSpinnerBox] = useState(false);
    const [expFlag, setExpFlag] = useState(false);
    const accessToken = sessionStorage.getItem('authToken');
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    var paramId = useParams().id;
    var propsId = props.userId;
    var params = propsId;
    if (!propsId) {
        params = paramId;
    }
    // console.log("props here",props)

    function getNextMonthDate() {
        const today = new Date();
        const nextMonth = new Date(today);
        nextMonth.setMonth(today.getMonth() + 1);

        if (nextMonth.getDate() !== today.getDate()) {
            nextMonth.setDate(0); // Set to the last day of the current month
        }
        const formattedDate = nextMonth.toISOString().split('T')[0];
        return formattedDate;
    }

    const oneMonthLater = getNextMonthDate();
    //console.log(oneMonthLater);

    useEffect(async () => {

        if (sessionStorage.getItem("userType") === "admin") {
            setUserId(-1);
        } else {
            setUserId(params);
        }
        if (userId !== undefined && userId !== "") {
            var selectedUserId = -1;
            if (props.userId != undefined) {
                selectedUserId = props.userId;
            }
            var apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "user/info/" + selectedUserId;
            await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                if (res.data !== undefined) {
                    //console.log("AccessList: ",res.data);
                    for (let data of res.data) {
                        setOrganisations(data.orgAccessIdList);
                        setHomes(data.homeAccessIdList);
                        setDefaultHomesList(data.homeAccessIdList);
                    }
                } else {
                    //setNewUser(intialState)
                }
            }).catch((error) => {
                console.error(error);
                // setshowSpinner(false);
            });
        }
    }, [userId]);




    const filterByHome = e => {
        setSpinnerBox(true);
        const { name, value } = e.target;
        sethomeDropdownValue(value);
        const selectedHome = homes.find((data) => data.home_id === value);
        if (selectedHome) {
            setHomeName(selectedHome.name);
        }

        setreportSection("");
        setSpinnerBox(false);
        if ((selectedReportType == 5 || selectedReportType == 6) && value != 0) {
            populateRoleDropDownData();
        }
    }

    const changeReportType = e => {
        const { name, value } = e.target;
        setselectedReportType(value);
        setselectedReportName(homeReportTypes.find((data) => data.value == value)?.name);
        if (value == 5 || value == 6) {
            populateRoleDropDownData();
        }
        setreportSection("");
    }

    const changeRole = e => {
        setSpinnerBox(true);
        const { name, value } = e.target;
        setselectedRole(value);
        setreportSection("");
        setSpinnerBox(false);
    }

    const populateRoleDropDownData = async () => {
        setSpinnerBox(true);
        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "audit-report/role-home-staff-summary/" + homeDropdownValue;
        var res = await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            setRoles(res.data);
            setSpinnerBox(false);
        }).catch((error) => {
            console.error(error);
            setSpinnerBox(false);
            setShowErrorPopup(true);
            setDataForErrorPopup("Error occured");
        });

    }

    const changeHomeByOrgId = (selectedOrgId) => {
        const homeListUrl = BASE_API_URL + "orgnization/getHomesList/" + selectedOrgId
        axios.get(homeListUrl, { headers })
            .then(res => {
                if (res.data != 'Something went wrong!' && res.data != 'No Home Found!') {
                    //setHomes(res.data)
                    var arr = [];
                    for (let data of res.data) {
                        //console.log("Outer: "+data.home_id);
                        homes.forEach(function (item, index) {
                            if (item.home_id == data.home_id) {
                                arr.push(data);
                                //console.log("Pushed: "+item.home_id);
                            }
                        })


                    }
                    //console.log("Array final: "+arr);
                    setHomes(arr);
                } else {
                    setHomes([])
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const resetOptions = () => {
        setSpinnerBox(true);
        //setRadioValue(1);
        setorgDropdownValue(0);
        sethomeDropdownValue(0);
        setselectedReportType(0);
        setselectedReportName('No report selected');
        setreportSection("");
        setFirstName("");
        setLastName("");
        setHomes(defaultHomesList);
        setExpDate({ 'startDate': (new Date()).toISOString().split('T')[0], 'endDate': getNextMonthDate() });
        setUserExpDate({ 'startDate': '', 'endDate': '' });
        setSpinnerBox(false);
    }

    const handleOnNameFilter = (e) => {
        setSpinnerBox(true);
        setreportSection("");
        const { name, value } = e.target;
        if (name === 'firstName') {
            setFirstName(value);
        } else {
            setLastName(value);
        }
        setSpinnerBox(false);
    }

    const fetchAuditReport = () => {
        //.log(selectedReportType)
        var component = "";
        var flag = true;
        var nameFilter = { "firstName": "", "lastName": "" }
        setSpinnerBox(true);
        setreportSection(component);
        if ((selectedReportType == 1 || selectedReportType == 2 || selectedReportType == 3) && orgDropdownValue == 0) {
            setSpinnerBox(false);
            setShowErrorPopup(true);
            setDataForErrorPopup("Please select an organization");
            flag = false;
        }
        if (selectedReportType >= 4 && homeDropdownValue == 0) {
            setSpinnerBox(false);
            setShowErrorPopup(true);
            setDataForErrorPopup("Please select a Home");
            flag = false;
        }
        if (selectedReportType == 2 || selectedReportType == 3 || selectedReportType == 5 || selectedReportType == 6) {
            nameFilter.firstName = firstName;
            nameFilter.lastName = lastName;
        }

        if(selectedReportType == 8 && (userExpDate.startDate == '' || userExpDate.endDate == '') && !expFlag){ 
            setShowErrorPopup(true);
            setDataForErrorPopup("Please select date range for course expiry");
            flag = false;
        }

        if (flag) {
            if (selectedReportType == 4) {
                component = () => {
                    return <HomeSummary homeId={homeDropdownValue} staffFlag={homeStaffStatusValue} crsPolicyType={homeCrsPolicyValue} />
                }

            }
            else if (selectedReportType == 10) {
                component = () => {
                    return <HomePolicySummary homeId={homeDropdownValue} roleId={selectedRole} filterBy={nameFilter} staffFlag={homeStaffStatusValue} />
                }

            }
            else if (selectedReportType == 11) {
                if (expDate.startDate && expDate.endDate && (new Date(expDate.startDate) < new Date(expDate.endDate))) {

                    component = () => {
                        return <PolicyExpiryReport homeId={homeDropdownValue} expDate={expDate} incExp={expFlag} staffFlag={homeStaffStatusValue} homeName={homeName} />
                    }
                    setExpDate({ 'startDate': (new Date()).toISOString().split('T')[0], 'endDate': getNextMonthDate() });
                }
                else {
                    setShowErrorPopup(true);
                    setDataForErrorPopup("Invalid filters - From-date/end-date required and from-date cannot be ahead of end-date");
                }

            }
            else if (selectedReportType == 5) {
                component = () => {
                    return <HomeStaffSummary homeId={homeDropdownValue} roleId={selectedRole} filterBy={nameFilter} staffFlag={homeStaffStatusValue} crsPolicyType={homeCrsPolicyValue} />
                }

            } else if (selectedReportType == 6) {
                component = () => {
                    return <HomeDeficiencyReport homeId={homeDropdownValue} roleId={selectedRole} filterBy={nameFilter} staffFlag={homeStaffStatusValue} crsPolicyType={homeCrsPolicyValue} />
                }

            } else if (selectedReportType == 7) {
                component = () => {
                    return <AdminHomeCourse homeId={homeDropdownValue} staffFlag={homeStaffStatusValue} crsPolicyType={homeCrsPolicyValue} />
                }

            }
            else if (selectedReportType == 8) {

                if (expFlag || (userExpDate.startDate && userExpDate.endDate && (new Date(userExpDate.startDate) < new Date(userExpDate.endDate)))) {

                    component = () => {
                        return <CourseExpiryReport homeId={homeDropdownValue} expDate={userExpDate} incExp={expFlag} staffFlag={homeStaffStatusValue} homeName={homeName} category={homeCrsPolicyValue} />
                    }
                    //setExpDate({ 'startDate': (new Date()).toISOString().split('T')[0], 'endDate': getNextMonthDate() });
                }
                else {
                    setShowErrorPopup(true);
                    setDataForErrorPopup("Invalid filters - Start-date/end-date required and Start date cannot be ahead of End date");
                }

            }
            else if (selectedReportType == 9) {

                if (expDate.startDate && expDate.endDate && (new Date(expDate.startDate) < new Date(expDate.endDate))) {

                    component = () => {
                        // console.log("here")
                        return <FundedTrainingReport homeId={homeDropdownValue} expDate={expDate} incExp={expFlag} staffFlag={homeStaffStatusValue} homeName={homeName} />
                    }
                    setExpDate({ 'startDate': (new Date()).toISOString().split('T')[0], 'endDate': getNextMonthDate() });
                }
                else {
                    setShowErrorPopup(true);
                    setDataForErrorPopup("Invalid filters - From-date/end-date required and from-date cannot be ahead of end-date");
                }

            }
            setSpinnerBox(false);
            setreportSection(component);
        }



    }

    function addDateFilter1(event) {
        const [year, month, day] = (event.target.value).split('-').map(Number);
        const myDate = new Date(year, month - 1, day);
        var tempStartDate = { ...expDate };
        const formattedDate = `${myDate.getFullYear()}-${(myDate.getMonth() + 1).toString().padStart(2, '0')}-${myDate.getDate().toString().padStart(2, '0')}`;
        tempStartDate.startDate = formattedDate;
        setExpDate(tempStartDate)
        setUserExpDate(startDate => ({ ...startDate, startDate: formattedDate }));
    }

    function addDateFilter2(event) {
        const [year, month, day] = (event.target.value).split('-').map(Number);
        const myDate = new Date(year, month - 1, day);
        var tempEndDate = { ...expDate };
        const formattedDate = `${myDate.getFullYear()}-${(myDate.getMonth() + 1).toString().padStart(2, '0')}-${myDate.getDate().toString().padStart(2, '0')}`;
        tempEndDate.endDate = formattedDate;
        setExpDate(tempEndDate)
        setUserExpDate(endDate => ({ ...endDate, endDate: formattedDate }));
    }


    return (
        <div style={{ "margin": "1pc" }}>
            <Container fluid>
                <Row className="w-70" style={{ "minHeight": "30pc" }}>
                    <Col xs={12} md={3} className='shadow p-3 mb-1 bg-white' style={{ "border": "1px solid #dcdcd7", "borderRadius": "9px 0 0 9px" }}>
                        <Row>
                            <Form.Group as={Col} className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label><TbCircleNumber1 size={20} /> View by &nbsp; </Form.Label>
                                <ButtonGroup style={{ "width": "100%" }}>
                                    {radios.map((radio, idx) => (
                                        <ToggleButton
                                            className="mb-2"
                                            id="toggle-check"
                                            type="checkbox"
                                            variant="outline-success"
                                            checked={true}
                                            value={2}
                                        >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Form.Group>
                        </Row>
                        
                        <hr className='w-90'></hr>
                        <Form.Group as={Col} controlId="forOrg">
                            <Form.Label size="sm"><TbCircleNumber2 size={20} /> Preference</Form.Label>
                        </Form.Group>

                        <div>
                            <Row>
                                <Form.Group as={Col} controlId="forHome">
                                    <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>{homeLabel}</Form.Label>
                                    <Form.Select name="home" value={homeDropdownValue} onChange={filterByHome}>
                                        <option value="0" key="0" >--Select Home--</option>
                                        {homes?.map((data, id) => (
                                            <option value={data.home_id} key={data.home_id}>{data.name}</option>

                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                            {(selectedReportType != 7) &&
                                <Row style={{ "marginTop": "1pc" }}>
                                     {props.isChild?
                                    <Form.Group as={Col} className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Staff preference </Form.Label>
                                        <ButtonGroup style={{ "width": "100%" }}>
                                            {staffStatus.map((radio, idx) => (
                                                <ToggleButton
                                                    key={idx}
                                                    id={`radioStaffHome-${idx}`}
                                                    type="radio"
                                                    variant={'outline-success'}
                                                    name="homeStaff-radio"
                                                    size="sm"
                                                    //disabled={userId == -1?false:true}
                                                    value={radio.value}
                                                    checked={homeStaffStatusValue === radio.value}
                                                    onChange={(e) => { setHomeStaffStatusValue(e.currentTarget.value); setreportSection("") }}
                                                >
                                                    {radio.name == 'Archive' ? 'Archived' : radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>
                                    </Form.Group>:
                                    (props.fromUser)?
                                    <Form.Group as={Col} className="mb-3" controlId="exampleForm.ControlInput2">
                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Staff preference </Form.Label>
                                        <ButtonGroup style={{ "width": "100%" }}>
                                            {staffStatus.map((radio, idx) => (
                                                <ToggleButton
                                                    key={idx}
                                                    id={`radioStaffHome2-${idx}`}
                                                    type="radio"
                                                    variant={'outline-success'}
                                                    name="homeStaff2-radio"
                                                    size="sm"
                                                    //disabled={userId == -1?false:true}
                                                    value={radio.value}
                                                    checked={homeStaffStatusValue === radio.value}
                                                    onChange={(e) => { setHomeStaffStatusValue(e.currentTarget.value); setreportSection("") }}
                                                >
                                                    {radio.name == 'Archive' ? 'Archived' : radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>
                                    </Form.Group>:
                                    <Form.Group as={Col} className="mb-3" controlId="exampleForm.ControlInput3">
                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Staff preference </Form.Label>
                                        <ButtonGroup style={{ "width": "100%" }}>
                                            {staffStatus.map((radio, idx) => (
                                                <ToggleButton
                                                    key={idx}
                                                    id={`radioStaffHome3-${idx}`}
                                                    type="radio"
                                                    variant={'outline-success'}
                                                    name="homeStaff3-radio"
                                                    size="sm"
                                                    //disabled={userId == -1?false:true}
                                                    value={radio.value}
                                                    checked={homeStaffStatusValue === radio.value}
                                                    onChange={(e) => { setHomeStaffStatusValue(e.currentTarget.value); setreportSection("") }}
                                                >
                                                    {radio.name == 'Archive' ? 'Archived' : radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>
                                    </Form.Group>
                                    
                                    }
                                </Row>
                            }

                           <hr className="w-70"></hr>
                         <Row >
                            {props.isChild?
                            <Form.Group as={Col} className="mb-3" controlId="crsChildPolicy1">
                            
                            <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Category preference </Form.Label>

                             <ButtonGroup style={{ "width": "100%" }}>
                                    {crsPolicyType.map((radio, idx) => (
                                        <ToggleButton
                                             key={idx}
                                                    id={`crsChildPolicy1-${idx}`}
                                                    type="radio"
                                                    variant={'outline-success'}
                                                    name="crsChildPolicy1-radio"
                                                    size="sm"
                                                    value={radio.value}
                                                    checked={homeCrsPolicyValue === radio.value}
                                                    onChange={(e) => { setHomeCrsPolicyValue(e.currentTarget.value); setreportSection("");}}
                                        >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>


                           
                          </Form.Group>:
                          (props.fromUser==true)?
                          <Form.Group as={Col} className="mb-3" controlId="crsPolicy2">
                            
                             <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Category preference </Form.Label>

                             <ButtonGroup style={{ "width": "100%" }}>
                                    {crsPolicyType.map((radio, idx) => (
                                        <ToggleButton
                                             key={idx}
                                                    id={`crsPolicy2-${idx}`}
                                                    type="radio"
                                                    variant={'outline-success'}
                                                    name="crsPolicy2-radio"
                                                    size="sm"
                                                    value={radio.value}
                                                    checked={homeCrsPolicyValue === radio.value}
                                                    onChange={(e) => { setHomeCrsPolicyValue(e.currentTarget.value); setreportSection("");}}
                                        >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>


                           
                          </Form.Group>:
                          <Form.Group as={Col} className="mb-3" controlId="crsPolicy">
                            
                             <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Category preference </Form.Label>

                             <ButtonGroup style={{ "width": "100%" }}>
                                    {crsPolicyType.map((radio, idx) => (
                                        <ToggleButton
                                             key={idx}
                                                    id={`crsPolicy-${idx}`}
                                                    type="radio"
                                                    variant={'outline-success'}
                                                    name="crsPolicy-radio"
                                                    size="sm"
                                                    value={radio.value}
                                                    checked={homeCrsPolicyValue === radio.value}
                                                    onChange={(e) => { setHomeCrsPolicyValue(e.currentTarget.value); setreportSection("");}}
                                        >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>


                           
                          </Form.Group>
                            }
                          
                        </Row>

                        </div>

                        <hr className='w-90'></hr>
                        <Row>
                            <Form.Group as={Col} controlId="forType">
                                <Form.Label><TbCircleNumber3 size={20} /> Report type</Form.Label>
                                <Form.Select name="type" value={selectedReportType} onChange={changeReportType}>
                                    <option value="0" key="0" >--Select type--</option>
                                    {homeReportTypes?.map((data, id) => (
                                        <option value={data.value} key={data.value}>{data.name}</option>
                                    ))}

                                </Form.Select>
                            </Form.Group>
                        </Row>

                        <br></br>
                        {(radioValue == 2 && (selectedReportType == 5 || selectedReportType == 6)) &&
                            <div>
                                <Row>
                                    <Form.Group as={Col} controlId="forType">
                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Role</Form.Label>
                                        <Form.Select name="type" value={selectedRole} onChange={changeRole}>
                                            <option value="0" key="0">All</option>
                                            {roles?.map((data, id) => (
                                                <option value={data.role_id} key={data.role_id}>{data.role_name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Row>
                                <br></br>
                            </div>
                        }
                        {(selectedReportType == 2 || selectedReportType == 3 || selectedReportType == 5 || selectedReportType == 6) &&
                            <div>
                                <Row>
                                    <Form.Group as={Col} controlId="forType">
                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>First Name</Form.Label>
                                        <Form.Control type="input" name="firstName" onChange={handleOnNameFilter} value={firstName} placeholder="Filter by first name" />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="forType">
                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Last Name</Form.Label>
                                        <Form.Control type="input" name="lastName" onChange={handleOnNameFilter} value={lastName} placeholder="Filter by last name" />
                                    </Form.Group>
                                </Row>
                                <br></br>
                            </div>
                        }

                        {(selectedReportType == 8 || selectedReportType == 11) &&
                            <div>

                                <Row style={{ "marginBottom": "1pc" }}>

                                    <Form.Group as={Col} controlId="dob">
                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Date From </Form.Label>

                                        <Form.Control type="date"
                                            onChange={(e) => {
                                                addDateFilter1(e);
                                            }}
                                        />
                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Date Till </Form.Label>

                                        <Form.Control type="date"
                                            onChange={(e) => {
                                                addDateFilter2(e);
                                            }}
                                        />
                                        <Row style={{ "marginTop": "1pc" }}>
                                            <Form.Group as={Col} className="mb-3" controlId="exampleForm.ControlInput1">

                                                <input as={Col} defaultChecked={expFlag} onChange={(e) => {
                                                    setExpFlag(e.target.checked);
                                                }} style={{ marginLeft: "2%" }} type='checkbox'></input>
                                                <Form.Label as={Col} className='col-sm-12 col-form-label form-control-sm' >Include Users with Expired Courses</Form.Label>

                                            </Form.Group>
                                        </Row>
                                    </Form.Group>
                                </Row>
                            </div>
                        }
                        {(selectedReportType == 9) &&
                            <div>

                                <Row style={{ "marginBottom": "1pc" }}>

                                    <Form.Group as={Col} controlId="dob">

                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Date From </Form.Label>
                                        <Form.Control type="date" onChange={(e) => { addDateFilter1(e); }} />

                                        <Form.Label className='col-sm-12 col-form-label form-control-sm' style={{ "color": "grey" }}>Date Till </Form.Label>
                                        <Form.Control type="date" onChange={(e) => { addDateFilter2(e); }} />

                                        <Row style={{ "marginTop": "1pc" }}>
                                            <Form.Group as={Col} className="mb-3" controlId="exampleForm.ControlInput1">

                                                <input as={Col} defaultChecked={expFlag} onChange={(e) => { setExpFlag(e.target.checked); }}
                                                    style={{ marginLeft: "2%" }} type='checkbox'></input>
                                                <Form.Label as={Col} className='col-sm-12 col-form-label form-control-sm' >Since last expiry</Form.Label>

                                            </Form.Group>
                                        </Row>
                                    </Form.Group>
                                </Row>
                            </div>
                        }


                            <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" gap={2}>
                                <JoyButton variant="solid" color='primary' onClick={(e) => {
                                    fetchAuditReport();
                                }}> Fetch Report</JoyButton>
                            
                                <JoyButton variant="solid" color='primary' startDecorator={<TbZoomReset />} onClick={(e) => {
                                    resetOptions();
                                }}>Reset</JoyButton>
                            </Stack>
                    
                    </Col>
                    <Col xs={12} md={9} style={{ "border": "1px solid #dcdcd7", "minHeight": "40pc", padding: "1pc", "borderRadius": "0 9px 9px 0" }} className='p-3 mb-1 bg-white' >
                        {/* Data */}
                         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "1pc" }}>
                                    <Typography level="title-md" sx={{color:"#006899"}} startDecorator={<DescriptionRoundedIcon />}> {selectedReportName}</Typography>
                            </Box>
                            <Box sx={{ maxHeight: "60pc", overflowY: "auto"}}>
                                {reportSection}
                            </Box>
                             <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "1pc" }}>
                                <Typography level='body-md'></Typography>
                            </Box>
                    </Col>
                </Row>
            </Container>
            <SpinnerBox show={spinnerBox} onHide={() => { setSpinnerBox(false) }} />
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false) }} />
        </div>
    );
}

export default HomeAuditReportManagement;